import { _event } from "./_event";
import { _localStyle } from "./_localStyle";

export type _fibonacciProps = {
    target: HTMLElement;
    type?: number;
    events?: Record<string, (self: _fibonacci) => void>;
};

export class _fibonacci {
    target: HTMLElement;
    type: number;

    el: {
        main: HTMLElement;
        center: HTMLElement;
        square: HTMLElement;
        circle: HTMLElement;
    };

    events: Record<string, (self: _fibonacci) => void>;
    listeners: Record<string, Array<(self: _fibonacci) => void>>;

    constructor(props: _fibonacciProps) {
        this.target = props.target;
        this.type = props.type ?? 1;

        this.el = {
            main: document.createElement("div"),
            center: document.createElement("div"),
            square: document.createElement("div"),
            circle: document.createElement("div"),
        };

        this.events = props.events || {};
        this.listeners = {};

        this.init();
    }

    init() {
        _localStyle();

        // main
        this.target.appendChild(this.el.main);
        this.el.main.classList.add(
            "absolute",
            "top-0",
            "left-0",
            "w-full",
            "h-full",
            "overflow-hidden",
            "pointer-events-none",
        );

        // center
        this.el.main.appendChild(this.el.center);
        this.el.center.classList.add("absolute", "top-0", "left-0", "w-[200vw]", "md:w-[130vw]", "h-full");

        // square
        this.el.center.appendChild(this.el.square);
        this.el.square.classList.add(
            "absolute",
            "top-0",
            "left-0",
            "w-full",
            "h-full",
            "border",
            "border-neutral-60/30",
            "md:border-neutral-60/50",
            "dark:border-neutral-10/30",
            "md:dark:border-neutral-10/50",
        );

        // circle
        this.el.center.appendChild(this.el.circle);
        this.el.circle.classList.add(
            "absolute",
            "top-0",
            "left-0",
            "w-full",
            "h-full",
            "border",
            "border-neutral-60/30",
            "md:border-neutral-60/50",
            "dark:border-neutral-10/30",
            "md:dark:border-neutral-10/50",
            "rounded-full",
        );

        // customization for type 1
        if (this.type === 1) {
            this.el.center.classList.remove("top-0", "left-0");
            this.el.center.classList.add("bottom-[1rem]", "md:bottom-[2rem]", "right-[1rem]", "md:right-[2rem]");

            this.el.circle.classList.remove("rounded-full");
            this.el.circle.classList.add("rounded-[60vw]", "md:rounded-full");
        }

        // for type 2
        if (this.type === 2) {
            this.el.center.classList.remove("left-0", "w-[200vw]", "h-full");
            this.el.center.classList.add(
                "left-[calc(100%-1rem)]",
                "md:left-[calc(100%-1.875rem)]",
                "w-[250vw]",
                "min-h-full",
                "h-screen",
            );
        }

        // for type 3
        if (this.type === 3) {
            this.el.main.classList.add("hidden", "md:block");

            this.el.center.classList.remove("left-0", "top-0");
            this.el.center.classList.add("left-[1rem]", "bottom-[1rem]", "md:bottom-[2rem]");
        }

        this.emit("init");

        _event.resize(() => {
            if (this.type === 2) {
                this.el.center.style.top = `${this.el.main.offsetHeight * 0.5 - this.el.center.offsetHeight * 0.5}px`;
            }

            this.emit("resize");
        });

        // console.log("_fibonacci", this);
    }

    on(event: string, callback: (self: _lightbox) => void) {
        if (!this.listeners[event]) this.listeners[event] = [];
        this.listeners[event].push(callback);
    }

    off(event: string, callback: (self: _lightbox) => void) {
        if (!this.listeners[event]) return;
        this.listeners[event] = this.listeners[event].filter((cb) => cb !== callback);
    }

    emit(event: string) {
        if (this.events[event]) this.events[event](this);

        if (!this.listeners[event]) return;
        this.listeners[event].forEach((callback) => callback(this));
    }
}
